import { RouteView, PageView } from '@/components/layouts'
import entrustRecord from '@/views/transationManage/brandHelp/entrustRecord'
import transationRecord from '@/views/transationManage/brandHelp/transationRecord'
import total from '@/views/transationManage/brandHelp/total'
export default {
  path: '/transationManage',
  name: '/transationManage',
  component: RouteView,
  meta: { title: '交易管理', keepAlive: false, icon: 'fa fa-credit-card-alt' },
  children: [
    {
      path: '/transationManage/brandHelp',
      name: '/transationManage/brandHelp',
      component: PageView,
      meta: { title: '品牌帮卖', keepAlive: false, icon: 'el-icon-star-on' },
      children: [
        {
          path: '/transationManage/brandHelp/entrustRecord',
          name: '/transationManage/brandHelp/entrustRecord',
          component: entrustRecord,
          meta: { title: '委托记录', keepAlive: false, action: [] }
        },
        {
          path: '/transationManage/brandHelp/transationRecord',
          name: '/transationManage/brandHelp/transationRecord',
          component: transationRecord,
          meta: { title: '成交记录', keepAlive: false, action: [] }
        },
        {
          path: '/transationManage/brandHelp/total',
          name: '/transationManage/brandHelp/total',
          component: total,
          meta: { title: '成交汇总', keepAlive: false, action: [] }
        },
      ]
    },
  ]
}
